'use client';

import classNames from 'classnames';
import { LandingRoadmap } from '@sapientpro/sapientpro-data-models/types/components/landing-page';
import styles from './IntegrationRoadmap.module.scss';
import AnimatedTitle from '../../../components/AnimatedTitle';
import Item from './Item';

const IntegrationRoadmap = ({
  data,
}: {
  data: LandingRoadmap;
}) => (
  <section className={classNames(styles.integrationRoadmap, 'container')}>
    <h2 className={classNames(styles.integrationRoadmap__title, 'header2')}>
      <AnimatedTitle title={data.title} />
    </h2>
    <div className={styles.integrationRoadmap__content}>
      <Item
        video={data.video.url}
        className={styles.integrationRoadmap__item}
      />
      {data.items.map((item, index) => (
        <Item
          key={item.id}
          item={{
            listNumber: index + 1,
            title: item.title,
            description: item.description,
          }}
          className={styles.integrationRoadmap__item}
        />
      ))}
    </div>
  </section>
);

export default IntegrationRoadmap;
